import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';

// Firebase configuration (replace with your actual config)
const firebaseConfig = {
    apiKey: "AIzaSyA7mRedZDwl-EdonSYYjbEiTo_BLjjcaNw",
    authDomain: "isabellebm-63f4f.firebaseapp.com",
    projectId: "isabellebm-63f4f",
    storageBucket: "isabellebm-63f4f.firebasestorage.app",
    messagingSenderId: "550534555915",
    appId: "1:550534555915:web:bf1d3d353e0cb4a91d5a0e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

/*
    User
*/
export const user = {
    id: '',
    name: '',
    jobTitle: '',
    address: '',
    phoneNumber: '',
    email: '',
    invoiceNumber: 0
};

export const saveUserToFirestore = async (userData) => {
    try {
        const existingUser = await getUserFromFirestore(userData.email);

        if (existingUser) {
            const userRef = doc(db, 'users', existingUser.id);
            await updateDoc(userRef, userData);
        } else {
            await addDoc(collection(db, 'users'), userData);
        }
    } catch (error) {
        console.error('Error saving user to Firestore:', error);
    }
};

export const getUserFromFirestore = async (email) => {
    try {
        const q = query(collection(db, 'users'), where('email', '==', email));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
            console.log('No matching user found.');
            return null;
        }

        let userData;
        snapshot.forEach(doc => {
            userData = { id: doc.id, ...doc.data() };
        });

        return userData;
    } catch (error) {
        console.error('Error retrieving user from Firestore:', error);
    }
};

export const updateUserInvoiceNumber = async (user, invoiceNumber) => {
    try {
        const existingUser = await getUserFromFirestore(user.email);

        const userRef = doc(db, 'users', existingUser.id);
        await updateDoc(userRef, { invoiceNumber });

        user.invoiceNumber = invoiceNumber;
        saveUserToLocalStorage(user);
    } catch (error) {
        console.error('Error updating invoice number:', error);
    }
};

export const saveUserToLocalStorage = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
};

export const getUserFromLocalStorage = () => {
    const userData = localStorage.getItem('user');

    if (userData) {
        return JSON.parse(userData);
    }

    console.log('No user found in local storage.');
    return null;
};

/*
    Invoice
*/
export const saveInvoiceToFirestore = async (invoiceData, userId) => {
    try {
        const invoicesCollection = collection(db, 'invoices');
        const searchIndex = createSearchIndex(invoiceData);

        await addDoc(invoicesCollection, { ...invoiceData, userId, searchIndex });
    } catch (error) {
        console.error('Error saving invoice to Firestore:', error);
    }
};

const createSearchIndex = (invoiceData) => {
    const index = [];

    for (const key in invoiceData) {
        //Only search on customer_name, invoice_number and date
        if (key === 'customer_name' || key === 'invoice_number' || key === 'date') {
            if (typeof invoiceData[key] === 'string') {
                index.push(...invoiceData[key].toLowerCase().split(' '));
            } else if (typeof invoiceData[key] === 'number') {
                index.push(invoiceData[key].toString());
            }
        }
    }

    return index;
};

export const updateInvoiceInFirestore = async (invoiceId, invoiceData) => {
    try {
        const invoiceRef = doc(db, 'invoices', invoiceId);
        invoiceData.searchIndex = createSearchIndex(invoiceData);
        await updateDoc(invoiceRef, invoiceData);
    } catch (error) {
        console.error('Error updating invoice:', error);
    }
};